import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'

interface Influencer {
  id: number
  name: string
  youtube_channel: string | null
  youtube_handle: string
  description: string | null
  episode_count: number | string
  prediction_count: number | string
}

export default function Influencers() {
  const [influencers, setInfluencers] = useState<Influencer[]>([])

  useEffect(() => {
    fetch('/api/intel/influencers')
      .then(r => r.ok ? r.json() as Promise<Influencer[]> : Promise.resolve([]))
      .then(setInfluencers)
      .catch(() => {})
  }, [])

  return (
    <div>
      <h2 className="text-xl sm:text-2xl font-bold mb-4 text-gray-900">KOLs</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {influencers.map(inf => {
          // Build YouTube channel URL from handle (CHO-198)
          const ytHandle = inf.youtube_handle
          const ytUrl = ytHandle
            ? ytHandle.startsWith('@')
              ? `https://youtube.com/${ytHandle}`
              : `https://youtube.com/c/${ytHandle}`
            : null

          return (
            <div key={inf.id} className="bg-white rounded-lg p-5 border border-gray-200 shadow-sm">
              <div className="flex justify-between items-start mb-2">
                <h3 className="text-lg font-semibold text-gray-900">{inf.name}</h3>
                <div className="flex items-center gap-2">
                  {/* YouTube profile link (CHO-198) */}
                  {ytUrl && (
                    <a
                      href={ytUrl}
                      target="_blank"
                      rel="noreferrer"
                      className="text-xs bg-red-50 text-red-600 hover:bg-red-100 px-2 py-0.5 rounded border border-red-200 transition-colors"
                      title={`YouTube: ${inf.youtube_handle}`}
                    >
                      YouTube
                    </a>
                  )}
                </div>
              </div>
              <p className="text-sm text-gray-600 mb-4">{inf.description}</p>
              <div className="flex gap-4 text-sm">
                <div>
                  <span className="text-gray-500">Episodes:</span>{' '}
                  <span className="font-medium text-gray-900">{Number(inf.episode_count)}</span>
                </div>
                <div>
                  <span className="text-gray-500">Predictions:</span>{' '}
                  <span className="font-medium text-gray-900">{Number(inf.prediction_count)}</span>
                </div>
              </div>
              <div className="flex gap-3 mt-3">
                {/* CHO-198: link to all-episodes tab with this KOL pre-filtered */}
                <Link
                  to={`/intel/episodes?influencer=${inf.id}`}
                  className="inline-block text-sm text-blue-600 hover:text-blue-700"
                >
                  All episodes &rarr;
                </Link>
                <Link
                  to={`/intel/influencers/${inf.id}/episodes`}
                  className="inline-block text-sm text-emerald-600 hover:text-emerald-700"
                >
                  Detail view &rarr;
                </Link>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
